<template>
  <!-- 签约方案 -->
  <div class="ContractPlan">
    <el-row>
      <el-col :span="8">
        <div class="grid-content bg-purple" style="display: flex;">
          <span style="width: 100px;padding-top: 11px;">方案名称:</span>
          <!-- <el-select placeholder="请选择方案" v-model="planName" clearable @change="seleValue">
            <el-option v-for="(item, index) in planNames" :key="index" :label="item" :value="item">
            </el-option>
          </el-select> -->

          <el-input v-model="planName" placeholder="请输入方案名称"></el-input>
        </div>
      </el-col>
      <el-col :span="6">
        <div style="display: flex;justify-content: center;">
          <div class="grid-content bg-purple-light" style="margin-right: 20px;"> <el-button type="primary" @click="seleValue1" class="btns" size="small" icon="el-icon-search">搜索</el-button></div>
          <div class="grid-content bg-purple-light"> <el-button type="primary" @click="addPlan1" class="btns" size="small" icon="el-icon-plus">添加方案</el-button></div>
        </div>
      </el-col>
    </el-row>
    <el-table :data="tableData" border height="600px" style="width: 95%;margin: 20px auto;" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
      <el-table-column label="方案名称" prop="signContractName" ></el-table-column>
      <el-table-column label="签约内容" prop="signContractContent" width="440px"></el-table-column>
      <el-table-column label="签约绑定数量" prop="signContractNumber" ></el-table-column>
      <el-table-column label="创建时间" prop="createTime" ></el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editCol(scope.row.id)">编辑</el-button>
          <el-button type="text" size="small" @click="delCol(scope.row.id)">删除</el-button>
          <el-button @click="handleClick(scope.row.id)" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>
    <el-dialog :title="isShowDialog ? '添加方案' : '编辑方案'" :visible.sync="dialogVisible" :close-on-click-modal = false>
      <el-form label-width="100px">
        <el-form-item label="方案名称:">
          <el-input v-model="addObj.planName" placeholder="请输入方案名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-circle-plus-outline" @click="addInput"></el-button>
          <el-button icon="el-icon-remove-outline" @click="removeItem"></el-button>
        </el-form-item>
        <el-form-item style="text-align: left;" v-for="(item, index) in addObj.planList" :key="index"
          :label="'第' + (index + 1) + '期'">
          <el-input @focus="clickInp(index)" v-model="item.classNum" size="small" style="width: 80%;"
            placeholder="请输入课节数"></el-input>
          <el-input size="small" style="width: 80%;" v-model="item.classPrice" placeholder="请输入课时单价"></el-input>
          <el-dialog :visible.sync="isShow" width="370px" append-to-body>
            <el-input style="width: 100px;" v-model="num"></el-input>---
            <el-input style="width: 100px;" v-model="num1"></el-input>
            <span class="text" @click="clickText">{{ text }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="isShow = false">取 消</el-button>
              <el-button type="primary" @click="determine(index)">确 定</el-button>
            </span>
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click='determinePlan'>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看详情" :visible.sync="viewDialog">
      <el-form>
        <el-form-item style="text-align: left;">
          <span>方案名称:{{ this.viewObj.planName }}</span>
        </el-form-item>
        <el-form-item style="text-align: left;" v-for="(item, index) in this.viewObj.planList" :key="index">
          <span>课时数:{{ item.classNum }}</span>
          <span style="margin-left: 50px;">课时单价:{{ item.classPrice }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialog = false">取 消</el-button>
        <el-button type="primary" @click="viewDialog = false">确 定</el-button>
      </span>
    </el-dialog>


    <div  class="box" v-if="isShowAddSigningPlan">
       <AddSigningPlan @handleToRetnrn="handleToRetnrn" :typeNode="typeNode" :isAdd="isAdd" :isShowAddSigningPlanID="isShowAddSigningPlanID" :isShowAddSigningPlanForbidden="isShowAddSigningPlanForbidden" v-if="isShowAddSigningPlan"></AddSigningPlan>
    </div>


  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";

import AddSigningPlan from './AddSigningPlan.vue';


export default {
  components: { AddSigningPlan },
  data () {
    return {
      isAdd: 1,
      isShowAddSigningPlan: false,
      isShowDialog: true,
      viewDialog: false,
      text: '+∞',
      num: "0",
      num1: "0",
      //添加方案
      addObj: {
        planName: "",
        planList: [],
      },
      viewObj: {
        planName: "",
        planList: [],
      },
      index: '',
      isShow: false,
      dialogVisible: false,
      total: 0,
      planName: '',
      planNames: [],//所有方案名称
      tableData: [],//table表格
      requestParameters: {
        pageSize: 10, //每页多少条
        pageNum: 1, //当前显示页码
      },

      isShowAddSigningPlanID:'',
      isShowAddSigningPlanForbidden: false,
      typeNode:'',

    }
  },
  created () {
    this.getPlanName()
    // this.getListData()
  },
  mounted(){
    let obj = {
        signContractName: this.planName,
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios.post(`${apiBaseUrl}/sign_contract/findPage`, obj,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if(res.data.code === 200){
            if(res.data.data.records.length > 0){
              this.tableData = res.data.data.records
            }else{
              this.tableData = []
            }
            this.requestParameters.pageNum = res.data.data.current
            this.requestParameters.pageSize = res.data.data.size
            this.total = res.data.data.total
          }else{
            this.$message.error(res.data.message)
          }
        }).catch(error => {
          console.error(error)
          this.$message.error(error)
      })
  },
  methods: {

    handleToRetnrn(event){
      this.isShowAddSigningPlan = event
      let obj = {
        signContractName: this.planName,
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios.post(`${apiBaseUrl}/sign_contract/findPage`, obj,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if(res.data.code === 200){
            if(res.data.data.records.length > 0){
              this.tableData = res.data.data.records
            }else{
              this.tableData = []
            }
            this.requestParameters.pageNum = res.data.data.current
            this.requestParameters.pageSize = res.data.data.size
            this.total = res.data.data.total
          }else{
            this.$message.error(res.data.message)
          }
        }).catch(error => {
          console.error(error)
          this.$message.error(error)
      })
    },
    //删除
    delCol (id) {

      this.$confirm('你确定要删除当前项吗?', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消', type: 'warning'}).then(() => {
        axios.post(`${apiBaseUrl}/sign_contract/delete/${id}`,{},{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              let obj = {
                signContractName: this.planName,
                pageNum: this.requestParameters.pageNum,
                pageSize: this.requestParameters.pageSize
              }
              axios.post(`${apiBaseUrl}/sign_contract/findPage`, obj,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                  if(res.data.code === 200){
                    if(res.data.data.records.length > 0){
                      this.tableData = res.data.data.records
                    }else{
                      this.tableData = []
                    }
                    this.requestParameters.pageNum = res.data.data.current
                    this.requestParameters.pageSize = res.data.data.size
                    this.total = res.data.data.total
                  }else{
                    this.$message.error(res.data.message)
                  }
                }).catch(error => {
                  console.error(error)
                  this.$message.error(error)
              })
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(error => {
            console.error(error);
            this.$message.error(error)
        })
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })

    },
    //搜索
    seleValue () {
      let obj = {
        planName: this.planName,
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios
        .post(`${apiBaseUrl}/contract/getList`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          console.log(res.data.data, 'res.data.data')
          this.tableData = res.data.data.records
          this.requestParameters.pageNum = res.data.data.current
          this.requestParameters.pageSize = res.data.data.size
          this.total = res.data.data.total

        })
        .catch(error => {
          console.error(error);
        });
    },
    seleValue1 () {
      let obj = {
        signContractName: this.planName,
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios.post(`${apiBaseUrl}/sign_contract/findPage`, obj,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if(res.data.code === 200){
            this.$message.success(res.data.message)
            if(res.data.data.records.length > 0){
              this.tableData = res.data.data.records
            }else{
              this.tableData = []
            }
            this.requestParameters.pageNum = res.data.data.current
            this.requestParameters.pageSize = res.data.data.size
            this.total = res.data.data.total
          }else{
            this.$message.error(res.data.message)
          }
        }).catch(error => {
          console.error(error)
          this.$message.error(error)
      })
    },
    handleSizeChange (pageSize) {
      this.requestParameters.pageSize = pageSize;
      if (this.requestParameters.page === 1) {

      }
      this.getListData(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.pageNum = newPage;
      this.getListData();
    },
    //获取table表数据
    getListData () {
      let obj = {
        pageNum: this.requestParameters.pageNum,
        pageSize: this.requestParameters.pageSize
      }
      axios
        .post(`${apiBaseUrl}/contract/getList`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
           console.log(res.data.data, 'res.data.data')
          this.tableData = res.data.data.records
          this.requestParameters.pageNum = res.data.data.current
          this.requestParameters.pageSize = res.data.data.size
          this.total = res.data.data.total
        })
        .catch(error => {
          console.error(error);
        });
    },
    //获取所有方案名
    getPlanName () {
      axios
        .get(`${apiBaseUrl}/contract/getPlanName`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {
          this.planNames = res.data.data
        })
        .catch(error => {
          console.error(error);
        });
    },
    //点击添加方案按钮
    addPlan () {
      this.isShowDialog = true
      this.addObj = {
        planName: "",
        planList: [],
      }
      this.dialogVisible = true
    },

    addPlan1(){
      this.isAdd = 1
      // this.$router.push('/AddSigningPlan')
      this.isShowAddSigningPlanID = ''
      this.isShowAddSigningPlanForbidden = false
      this.isShowAddSigningPlan = true
    },
    //编辑
    editCol (id) {
      this.isAdd = 2
      this.isShowAddSigningPlanID = id
      this.isShowAddSigningPlanForbidden = false
      this.isShowAddSigningPlan = true
      // this.isShowDialog = false
      // this.dialogVisible = true
      // axios
      //   .get(`${apiBaseUrl}/contract/getDetail?id=${id}`,{
      //     headers:{
      //       'authorization': sessionStorage.getItem('tokenInfo')
      //     }
      //   }) // 请替换为你的API URL
      //   .then(res => {
      //     this.addObj = res.data.data
      //   })
      //   .catch(error => {
      //     console.error(error);
      //   });
    },
    addInput () {
      this.addObj.planList.push({
        classNum: "",
        classPrice: ''
      });
    },
    //减少输入框
    removeItem () {
      // if (this.addList.length > 1) {
      this.addObj.planList.pop();
      // } else {
      //   this.addList.splice(0, this.addList.length);
      // }
    },
    //点击课节数input框
    clickInp (index) {
      this.index = index
      this.isShow = true
    },
    //确定
    determine () {
      this.addObj.planList[this.index].classNum = this.num + '---' + this.num1
      this.isShow = false
    },
    clickText () {
      this.num1 = this.text
    },
    //添加方案保存还是编辑方案保存
    determinePlan () {
      if (this.isShowDialog == true) {
        axios
          .post(`${apiBaseUrl}/contract/add`, this.addObj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(res => {
            if (res.data.code == 200) {
              this.dialogVisible = false
              this.$message.success(res.data.message)
              this.getListData()
              this.getPlanName()
            } else {
              this.dialogVisible = false
              this.$message.error(res.data.message)
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        axios
          .post(`${apiBaseUrl}/contract/update`, this.addObj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
          .then(res => {
            if (res.data.code == 200) {
              this.dialogVisible = false
              this.$message.success(res.data.message)
              this.getListData()
              this.getPlanName()
            } else {
              this.dialogVisible = false
              this.$message.error(res.data.message)
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    //查看详情
    handleClick (id) {

      this.typeNode = '查看'
      this.isShowAddSigningPlanID = id
      this.isShowAddSigningPlanForbidden = true
      this.isShowAddSigningPlan = true
      // this.viewDialog = true
      // axios
      //   .get(`${apiBaseUrl}/contract/getDetail?id=${id}`,{
      //     headers:{
      //       'authorization': sessionStorage.getItem('tokenInfo')
      //     }
      //   }) // 请替换为你的API URL
      //   .then(res => {
      //     this.viewObj = res.data.data
      //     console.log(this.viewObj);
      //   })
      //   .catch(error => {
      //     console.error(error);
      //   });
    }
  }
}
</script>

<style scoped>
.text {
  display: inline-block;
  font-size: 22px;
  border: 1px solid #ccc;
  width: 50px;
  height: 38px;
  border-radius: 5px;
}

@media screen and (max-width: 750px) {
  .ContractPlan {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  .ContractPlan>>>.el-dialog {
    width: 100% !important;
  }

  /* .ContractPlan>.el-dialog>>>.el-dialog {
    width: 100% !important;
  } */
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

.box{
    position: fixed;
    background: #fff;
    width: 100%;
    z-index: 1111;
    top: 0;
    left: 0;
    height: 100vh;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/NewSigningPlanFiles/SigningPlan.vue